import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanicControlComponent } from './panic-control.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [PanicControlComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class PanicControlModule { }
